export default __webpack_public_path__ + "static/media/logo3.9ac3c71a.png";